import { rackSizeOptions } from "@/common/const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const rackAndSpaceManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "select",
    label: "Rack Size",
    name: "rackSize",
    required: true,
    options: rackSizeOptions,
    defaultValue: rackSizeOptions[0].value,
  },
  {
    inputType: "text",
    label: "Power",
    name: "power",
    required: true,
  },
  {
    inputType: "text",
    label: "Quantity",
    name: "quantity",
    required: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    defaultValue: contractTermsOptions[0].value,
  },
];
export default rackAndSpaceManualFormStrategy;
